import selectPublicPrice from './select-public-price';
import {createSelector} from '@reduxjs/toolkit';

export default (coe: number) =>
  createSelector([selectPublicPrice], publicPrice => {
    return Number(publicPrice) * coe;
  });
